<script setup lang="ts">
import { site } from '@/i18n'
// 标准保护伞徽 — 与 admin-tsx shared-tsx/ui/UmbrellaLogo.tsx 曲瓣风车几何一致:
// 8 片弯曲扇叶(圆心 32,32, 半径 31, Q 曲线同向旋掠), 红 #E60012 / 白交替,
// 中心深灰毂 r5 + 白点 r2.5。曲瓣几何让旋转过程清晰可辨 (直边瓣旋转几乎看不出)
// spin: 持续旋转 (与 admin-tsx force 模式对齐: 不受 prefers-reduced-motion 影响, 永远转)
// 参数同 admin-tsx: 2s/圈 顺时针
const blades = [
  'M32 32 L63 32 Q53.20 40.78 53.92 53.92 Z',
  'M32 32 L53.92 53.92 Q40.78 53.20 32 63 Z',
  'M32 32 L32 63 Q23.22 53.20 10.08 53.92 Z',
  'M32 32 L10.08 53.92 Q10.80 40.78 1 32 Z',
  'M32 32 L1 32 Q10.80 23.22 10.08 10.08 Z',
  'M32 32 L10.08 10.08 Q23.22 10.80 32 1 Z',
  'M32 32 L32 1 Q40.78 10.80 53.92 10.08 Z',
  'M32 32 L53.92 10.08 Q53.20 23.22 63 32 Z'
]

withDefaults(defineProps<{ badge?: boolean; spin?: boolean }>(), {
  badge: true,
  spin: false
})
</script>

<template>
  <div class="umb-logo-root" aria-hidden="true">
    <svg class="umb-logo" viewBox="0 0 64 64" role="img" :aria-label="site.brand.name">
      <rect v-if="badge" width="64" height="64" rx="14" fill="#0d1017" />
      <g class="umb-face" :class="{ spin }">
        <path v-for="(d, i) in blades" :key="d" :d="d" :fill="i % 2 === 0 ? 'var(--u2-primary)' : '#ffffff'" />
        <circle cx="32" cy="32" r="5" fill="#1f2937" />
        <circle cx="32" cy="32" r="2.5" fill="#ffffff" />
      </g>
    </svg>
  </div>
</template>

<style scoped>
.umb-logo-root {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.umb-logo {
  display: block;
}

/* 只转伞面不转徽章底板 */
.umb-face {
  transform-origin: 32px 32px;
  will-change: transform;
}

/* 强制永转 (admin-tsx force 同款): 不包 reduced-motion 媒体查询, 系统关动画也照转 */
.umb-face.spin {
  animation: umb-logo-spin 2s linear infinite;
}

@keyframes umb-logo-spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
